(function () {
    var N_ = function (s) { return s; };
    var __ = function (s) { var a = Array.prototype.slice.call(arguments, 1); return typeof window.__ === 'function' ? window.__.apply(null, arguments) : s.replace(/\{([0-2])\}/g, function (m, n) { return a[n] != null ? String(a[n]) : m; }); };
    var CDN = 'https://cdn.sharkguitars.com/';
    var PICKUP_CATS = window.SharkSpecFacts.PICKUP_CATS;
    var FX_CATS = { mini: 20, main1: 21, main2: 24 };
    var BODY_HARDWARE_SLOTS = [
        { parentId: 348, categoryId: 12, label: N_('BRIDGE BASE PLATE') },
        { parentId: 351, categoryId: 12, label: N_('SADDLE BLOCK') },
        { parentId: 747, categoryId: 12, label: N_('ROLLERS') },
        { parentId: 737, categoryId: 12, label: N_('TUNERS & ARM CAPS') },
        { parentId: 742, categoryId: 12, label: N_('TREMOLO ARM') },
        { parentId: 755, categoryId: 10, label: N_('PICKUP FRAMES') },
        { parentId: 362, categoryId: 14, label: N_('CONTROL KNOBS') }
    ];
    var NECK_COSMETIC_SLOTS = [
        { parentId: 9, categoryId: 11, label: N_('INLAY DESIGN') },
        { parentId: 446, categoryId: 11, label: N_('INLAY MATERIAL') },
        { parentId: 502, categoryId: 11, label: N_('SIDE DOTS') },
        { parentId: 1325, categoryId: 11, label: N_('BINDING') }
    ];
    var NUT_SLOTS = [
        { parentId: 354, categoryId: 18, label: N_('BASE PLATE') },
        { parentId: 1474, categoryId: 18, label: N_('STRING CARRIER') }
    ];
    var systems = [];
    var storeBuild = [];
    var currentFamily = 0;
    var choiceView = 'status';
    var choiceSlot = '';
    var fretCountDraft = '';
    var draft = null;
    var returnFocus = null;
    var previousOverflow = '';
    var resetReturnFocus = null;
    var resetPreviousOverflow = '';
    var bound = false;
    var overlay, dialogBody, dialogTitle, dialogExplanation, helpTitle, helpCopy, pendingLabel, commitStatus, applyButton, priceChange, resetOverlay, choiceSr;

    function getCmp(id) { return window.sharkDmxCmp ? window.sharkDmxCmp(id) : null; }

    function getSrvData() { var data = window.sharkSrvProductData ? window.sharkSrvProductData() : null; return data && data.product ? data : null; }

    function meta() { return window.SHARK_ITEM_META || {}; }
    function norm(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
    var esc = window.SharkSpecFacts.esc;

    function currency() {
        var l1 = dmx.app.data.local1 && dmx.app.data.local1.data || {};
        return { rate: Number(l1.currency_exchange_rate) || 1, name: l1.currencyName || N_('USD') };
    }

    function money(amount) {
        var cur = currency();
        return window.sharkMoney(Math.abs(amount) * cur.rate, cur.name);
    }

    function deltaText(delta) {
        if (delta == null) return N_('PRICE TBD');
        if (delta === 0) return '—';
        return (delta > 0 ? '+' : '−') + money(delta);
    }

    function deltaClass(delta) {
        if (delta == null) return ' unavailable';
        return delta > 0 ? ' plus' : delta < 0 ? ' minus' : ' neutral';
    }

    function optionCopyIndex() {
        var out = {};
        var rows = meta().option_copy || {};
        Object.keys(rows).forEach(function (key) {
            var split = key.indexOf('|');
            var family = key.slice(0, split);
            if (!out[family]) out[family] = {};
            out[family][norm(key.slice(split + 1))] = rows[key];
        });
        return out;
    }

    function findCopy(familyId, candidates) {
        var families = optionCopyIndex();
        var index = families[familyId] || {};
        for (var i = 0; i < candidates.length; i++) {
            var hit = index[norm(candidates[i])];
            if (hit) return hit;
        }
        return null;
    }

    function profileMetaFor(name) { return window.SharkSpecFacts.profileMetaFor(meta(), name); }

    function pickupComponentMeta(modelName, categoryId) {
        return window.SharkSpecFacts.pickupComponentRecord(meta(), modelName, categoryId === PICKUP_CATS.neck ? 'Neck' : 'Bridge');
    }

    function fxCodeOf(modelName) { return window.SharkSpecFacts.fxCodeOf(meta(), modelName); }

    function outputFromName(modelName) {
        var match = String(modelName || '').match(/\(([^)]+)\)/);
        return match ? match[1].replace(/\s*Output\s*/i, '').trim() : '';
    }

    function fretCountValue(label) { return (String(label || '').match(/\b(22|24)\b/) || [])[1] || ''; }
    function fretMaterialLabel(label) {
        if (/fretless/i.test(label)) return N_('FRETLESS');
        return /titanium/i.test(label) ? N_('TITANIUM') : N_('S.STEEL');
    }
    function fretCopyCandidates(label) {
        var count = fretCountValue(label);
        var material = /titanium/i.test(label) ? N_('TI') : N_('SS');
        return /fretless/i.test(label) ? ['Fretless ' + count, label] : [count + ' ' + material, label];
    }
    // The body's routing group is resolved by json_key, never by a hardcoded property id: tree ids drift
    // between local and prod, and a wrong id would make the sync a silent no-op.
    function bodyFretRows(data) {
        return ((data && data.availableProperties) || []).filter(function (row) { return row.property_json_key === 'body_fret_count'; });
    }
    function bodyFretParent(data) {
        var rows = bodyFretRows(data);
        return rows.length ? Number(rows[0].property_parent_id) : 0;
    }
    function bodyFretOptionFor(count) {
        var rows = bodyFretRows(getSrvData());
        return rows.find(function (row) { return String(row.property_json_value) === String(count); })
            || rows.find(function (row) { return fretCountValue(row.property_name) === String(count); })
            || null;
    }
    // The body carries its own fret-count routing (FRET COUNT - BODY). A neck fret change must drag it
    // along, otherwise the 3D scene loads a 24-fret body under a 22-fret neck and the spec sheet flags a
    // routing conflict. Passing no count restores the stored body value.
    function syncBodyFretCount(count) {
        var data = getSrvData();
        if (!data || !partByCategory(data, 10)) return;
        var parentId = bodyFretParent(data);
        if (!parentId) return;
        var storeRow = propertyRowOnPart(data, 10, parentId);
        var target = count ? bodyFretOptionFor(count) : null;
        if (count && !target) return;
        var propertyId = target ? Number(target.property_id) : (storeRow ? Number(storeRow.property_id) : '');
        var delta = target && target.delta_price != null ? Number(target.delta_price) : 0;
        window.setGuitarPropertyOnPart(10, parentId, propertyId, delta);
    }
    function scaleCopyCandidates(label) {
        if (/24\.75/.test(label)) return [N_('Short · 24.75″'), label];
        if (/25\.5/.test(label)) return [N_('Long · 25.5″'), label];
        return [label];
    }
    function packCopyCandidates(label) {
        return [String(label).replace(/\s*FX Pack$/i, '').replace(/\s*Pack$/i, ''), label, String(label).split(/\s+/)[0]];
    }

    function neckPart(data) {
        return (data.properties || []).find(function (part) { return Number(part.category_id) === 11; });
    }

    function neckPropertyByParent(data, parentId) {
        var part = neckPart(data);
        var rows = (part && part.property) || [];
        return rows.find(function (row) { return Number(row.property_parent_id) === parentId; }) || null;
    }

    function partByCategory(data, categoryId) {
        return (data.properties || []).find(function (part) { return Number(part.category_id) === categoryId; }) || null;
    }

    function overridesItems() {
        var c = getCmp('varGuitarOverrides');
        return (c && c.data && c.data.items) ? c.data.items : [];
    }

    function propertyRowOnPart(data, categoryId, parentId) {
        var part = partByCategory(data, categoryId);
        var rows = (part && part.property) || [];
        return rows.find(function (row) { return Number(row.property_parent_id) === Number(parentId); }) || null;
    }

    function propertyOverrideOnPart(part, parentId) {
        if (!part) return null;
        return overridesItems().find(function (item) {
            return item.override_type === 'property'
                && Number(item.property_parent_id) === Number(parentId)
                && Number(item.design_part_id) === Number(part.design_part_id);
        }) || null;
    }

    function modelOverride(designPartId) {
        return overridesItems().find(function (item) {
            return item.override_type === 'model' && Number(item.design_part_id) === Number(designPartId);
        }) || null;
    }

    function buildGuitarSystems() {
        var data = getSrvData();
        if (!data) return [];
        var list = [];
        var groups = {};
        (data.availableProperties || []).forEach(function (row) {
            var pid = Number(row.property_parent_id);
            if (!groups[pid]) groups[pid] = { name: row.property_parent_name, options: [] };
            groups[pid].options.push(row);
        });
        var profileTypeRow = neckPropertyByParent(data, 2);
        var customProfile = !profileTypeRow || Number(profileTypeRow.property_id) !== 1394;

        [{ pid: 8, id: 'frets', label: N_('Frets'), copyFn: fretCopyCandidates },
         { pid: 440, id: 'scale', label: N_('Scale'), copyFn: scaleCopyCandidates },
         { pid: 1394, id: 'neckProfile', label: N_('Neck Profile'), copyFn: function (l) { return [l]; } }].forEach(function (fam) {
            var group = groups[fam.pid];
            if (!group) return;
            var currentRow = neckPropertyByParent(data, fam.pid);
            var storeId = currentRow ? Number(currentRow.property_id) : null;
            var override = propertyOverrideOnPart(partByCategory(data, 11), fam.pid);
            var storeRow = group.options.find(function (row) { return Number(row.property_id) === storeId; });
            var storeIsFretless = fam.id === 'frets' && !!storeRow && /fretless/i.test(storeRow.property_name);
            var options = group.options.map(function (row) {
                if (fam.id === 'frets' && /fretless/i.test(row.property_name)) return null;
                var copy = findCopy(fam.id, fam.copyFn(row.property_name));
                return {
                    id: Number(row.property_id),
                    label: row.property_name,
                    delta: row.delta_price == null ? null : Number(row.delta_price),
                    description: (copy && copy.description) || ''
                };
            }).filter(Boolean);
            var familyCopy = (meta().family || {})[fam.id] || {};
            var profileLocked = fam.id === 'neckProfile' && customProfile;
            list.push({
                id: fam.id,
                kind: 'property',
                parentId: fam.pid,
                // These three all live on the neck part; applyDraft writes part-scoped.
                categoryId: 11,
                label: fam.label,
                readoutLabel: familyCopy.readoutLabel || fam.label.toUpperCase(),
                description: familyCopy.description || '',
                options: options,
                storeSelected: storeId,
                selected: override ? Number(override.property_id) : storeId,
                storeIsFretless: storeIsFretless,
                disabled: profileLocked || storeIsFretless,
                disabledNote: storeIsFretless ? N_('Fretless neck - fret options are managed in the 3D Designer.') : (profileLocked ? N_('Template override unavailable - this guitar uses a custom neck profile.') : '')
            });
        });

        var pickupSlots = ['bridge', 'neck'].map(function (slotId) {
            var cat = PICKUP_CATS[slotId];
            var part = partByCategory(data, cat);
            if (!part) return null;
            var override = modelOverride(part.design_part_id);
            return {
                id: slotId,
                categoryId: cat,
                label: slotId === 'bridge' ? N_('BRIDGE PICKUP') : N_('NECK PICKUP'),
                designPartId: Number(part.design_part_id),
                storeModelId: Number(part.model_id),
                storeModelName: part.part_name,
                modelId: override ? Number(override.override_model_id) : Number(part.model_id)
            };
        }).filter(Boolean);
        if (pickupSlots.length) {
            var pickupFamilyCopy = (meta().family || {}).pickupSet || {};
            list.push({
                id: 'pickupSet',
                kind: 'pack',
                packType: 'pickup',
                label: N_('Pickup Set'),
                readoutLabel: pickupFamilyCopy.readoutLabel || N_('PICKUPS'),
                description: pickupFamilyCopy.description || '',
                categories: pickupSlots.map(function (slot) { return slot.categoryId; }),
                packs: (data.availablePacks || []).filter(function (pack) { return pack.pack_type === 'pickup'; }),
                slots: pickupSlots,
                packVarId: 'varGuitarPickupPack'
            });
        }

        var fxSlots = [['mini', FX_CATS.mini, N_('MINI FX')], ['main1', FX_CATS.main1, N_('FX SLOT 1')], ['main2', FX_CATS.main2, N_('FX SLOT 2')]].map(function (def) {
            var part = partByCategory(data, def[1]);
            if (!part) return null;
            var override = modelOverride(part.design_part_id);
            return {
                id: def[0],
                categoryId: def[1],
                label: def[2],
                designPartId: Number(part.design_part_id),
                storeModelId: Number(part.model_id),
                storeModelName: part.part_name,
                modelId: override ? Number(override.override_model_id) : Number(part.model_id)
            };
        }).filter(Boolean);
        if (fxSlots.length) {
            var fxFamilyCopy = (meta().family || {}).fxPack || {};
            list.push({
                id: 'fxPack',
                kind: 'pack',
                packType: 'fx_card',
                label: N_('FX Pack'),
                readoutLabel: fxFamilyCopy.readoutLabel || N_('FX CARDS'),
                description: fxFamilyCopy.description || '',
                categories: fxSlots.map(function (slot) { return slot.categoryId; }),
                packs: (data.availablePacks || []).filter(function (pack) { return pack.pack_type === 'fx_card'; }),
                slots: fxSlots,
                packVarId: 'varGuitarFXPack'
            });
        }
        return list;
    }

    function propertyGroupsFrom(data) {
        var groups = {};
        (data.availableProperties || []).forEach(function (row) {
            var pid = Number(row.property_parent_id);
            if (!groups[pid]) groups[pid] = { name: row.property_parent_name, options: [] };
            groups[pid].options.push(row);
        });
        return groups;
    }

    function swatchHex(row) {
        var value = String(row.property_json_value == null ? '' : row.property_json_value).trim();
        if (value.charAt(0) !== '#') return '';
        return value.split(',')[0].trim();
    }

    function optionsFrom(group, familyId) {
        return (group.options || []).map(function (row) {
            var copy = findCopy(familyId, [row.property_name]);
            return {
                id: Number(row.property_id),
                label: String(row.property_name || '').trim(),
                delta: row.delta_price == null ? null : Number(row.delta_price),
                hex: swatchHex(row),
                description: (copy && copy.description) || ''
            };
        });
    }

    function familyCopyFor(id, fallbackLabel) {
        var copy = (meta().family || {})[id] || {};
        return {
            readoutLabel: copy.readoutLabel || String(fallbackLabel).toUpperCase(),
            description: copy.description || ''
        };
    }

    function buildPropertyFamily(data, groups, def) {
        var group = groups[def.parentId];
        if (!group) return null;
        var part = partByCategory(data, def.categoryId);
        var currentRow = propertyRowOnPart(data, def.categoryId, def.parentId);
        if (!currentRow) return null;
        var storeId = Number(currentRow.property_id);
        // Part-scoped like its propertyGroup sibling: a parent id reused under a second
        // part would otherwise resolve to whichever override landed first.
        var override = propertyOverrideOnPart(part, def.parentId);
        var copy = familyCopyFor(def.id, def.label);
        return {
            id: def.id,
            kind: 'property',
            parentId: def.parentId,
            categoryId: def.categoryId,
            label: def.label,
            readoutLabel: copy.readoutLabel,
            description: copy.description,
            options: optionsFrom(group, def.id),
            storeSelected: storeId,
            selected: override ? Number(override.property_id) : storeId,
            disabled: false,
            disabledNote: ''
        };
    }

    function buildPropertyGroupFamily(data, groups, def) {
        var slots = def.slots.map(function (slotDef) {
            var group = groups[slotDef.parentId];
            if (!group || !group.options.length) return null;
            var currentRow = propertyRowOnPart(data, slotDef.categoryId, slotDef.parentId);
            if (!currentRow) return null;
            var part = partByCategory(data, slotDef.categoryId);
            var storeId = Number(currentRow.property_id);
            var override = propertyOverrideOnPart(part, slotDef.parentId);
            return {
                storeLabel: String(currentRow.design_part_property_value || '').trim(),
                id: 'p' + slotDef.parentId,
                parentId: slotDef.parentId,
                categoryId: slotDef.categoryId,
                designPartId: Number(part.design_part_id),
                label: slotDef.label,
                options: optionsFrom(group, def.id),
                storeSelected: storeId,
                selected: override ? Number(override.property_id) : storeId
            };
        }).filter(Boolean);
        if (!slots.length) return null;
        var copy = familyCopyFor(def.id, def.label);
        var family = {
            id: def.id,
            kind: 'propertyGroup',
            label: def.label,
            readoutLabel: copy.readoutLabel,
            description: copy.description,
            slots: slots
        };
        if (def.preset) family.presetOptions = presetOptionsFor(slots);
        return family;
    }

    // A colour family covers several sockets that physically share one finish, so it is
    // picked once: every option below exists under every slot's own parent, with its own
    // property_id and its own delta.
    function presetOptionsFor(slots) {
        var first = slots[0].options || [];
        var out = [];
        first.forEach(function (option) {
            var perSlot = {};
            var delta = 0;
            var resolvable = slots.every(function (slot) {
                var match = (slot.options || []).find(function (candidate) { return candidate.label === option.label; });
                if (!match) return false;
                perSlot[slot.id] = match.id;
                if (match.delta == null) delta = null;
                else if (delta != null) delta += match.delta;
                return true;
            });
            if (resolvable) out.push({ label: option.label, hex: option.hex, description: option.description, delta: delta, perSlot: perSlot });
        });
        return out.length ? out : null;
    }

    function presetValue(system) {
        if (!system.presetOptions) return null;
        var names = system.slots.map(function (slot) { return slotValueLabel(slot); });
        var first = names[0];
        return names.every(function (name) { return name === first; }) ? first : N_('MIXED');
    }

    function presetOptionByLabel(system, label) {
        return (system.presetOptions || []).find(function (option) { return option.label === label; }) || null;
    }

    function buildModelFamily(data, def) {
        var part = partByCategory(data, def.categoryId);
        if (!part) return null;
        if (swapsFor(def.categoryId).length < 2) return null;
        var override = modelOverride(part.design_part_id);
        var copy = familyCopyFor(def.id, def.label);
        return {
            id: def.id,
            kind: 'model',
            label: def.label,
            readoutLabel: copy.readoutLabel,
            description: copy.description,
            slots: [{
                id: def.id,
                categoryId: def.categoryId,
                label: def.label,
                designPartId: Number(part.design_part_id),
                storeModelId: Number(part.model_id),
                storeModelName: part.part_name,
                modelId: override ? Number(override.override_model_id) : Number(part.model_id)
            }]
        };
    }

    function buildBodySystems(data) {
        var groups = propertyGroupsFrom(data);
        return [
            buildPropertyGroupFamily(data, groups, { id: 'hardware', label: N_('Hardware'), slots: BODY_HARDWARE_SLOTS, preset: true }),
            buildModelFamily(data, { id: 'electronics', label: N_('Electronics'), categoryId: 14 }),
            buildPropertyFamily(data, groups, { id: 'fretRouting', label: N_('Fret Routing'), parentId: 186, categoryId: 10 })
        ].filter(Boolean);
    }

    function buildNeckSystems(data) {
        var groups = propertyGroupsFrom(data);
        var stained = !!propertyRowOnPart(data, 11, 452);
        return [
            buildFretFamily(data, groups),
            buildPropertyFamily(data, groups, { id: 'scale', label: N_('Scale'), parentId: 440, categoryId: 11 }),
            buildPropertyGroupFamily(data, groups, { id: 'cosmetics', label: N_('Cosmetics'), slots: NECK_COSMETIC_SLOTS }),
            buildPropertyFamily(data, groups, { id: 'headstock', label: N_('Headstock'), parentId: 733, categoryId: 11 }),
            buildPropertyFamily(data, groups, { id: 'neckColour', label: N_('Colour'), parentId: stained ? 452 : 6574, categoryId: 11 }),
            buildPropertyGroupFamily(data, groups, { id: 'nut', label: N_('Nut'), slots: NUT_SLOTS, preset: true })
        ].filter(Boolean);
    }

    function buildFretFamily(data, groups) {
        var family = buildPropertyFamily(data, groups, { id: 'frets', label: N_('Frets'), parentId: 8, categoryId: 11 });
        if (!family) return null;
        var storeRow = family.options.find(function (option) { return Number(option.id) === Number(family.storeSelected); });
        family.storeIsFretless = !!storeRow && /fretless/i.test(storeRow.label);
        family.options = family.options.filter(function (option) { return !/fretless/i.test(option.label); });
        family.disabled = family.storeIsFretless;
        family.disabledNote = family.storeIsFretless ? N_('Fretless neck - fret options are managed in the 3D Designer.') : '';
        return family;
    }

    function buildSystems() {
        var data = getSrvData();
        if (!data || !data.product) return [];
        var category = Number(data.product.category_id);
        if (category === 10) return buildBodySystems(data);
        if (category === 11) return buildNeckSystems(data);
        return buildGuitarSystems();
    }

    function swapsFor(categoryId) {
        var data = getSrvData();
        return ((data && data.availableSwaps) || []).filter(function (swap) { return Number(swap.category_id) === categoryId; });
    }

    function swapByModel(categoryId, modelId) {
        return swapsFor(categoryId).find(function (swap) { return Number(swap.model_id) === Number(modelId); }) || null;
    }

    function packItemsFor(packId) {
        var data = getSrvData();
        return ((data && data.availablePackItems) || []).filter(function (item) { return Number(item.pack_id) === Number(packId); });
    }

    function packSlotModel(system, pack, slot) {
        var items = packItemsFor(pack.pack_id);
        var wanted = norm(slot.categoryIdName || '');
        var byCategory = items.find(function (item) { return Number(item.category_id) === slot.categoryId; });
        if (byCategory) return byCategory;
        return items.find(function (item) { return norm(item.category_name).indexOf(wanted) >= 0; }) || null;
    }

    function matchingPack(system) {
        return window.SharkSpecFacts.matchPack(system.packs || [], packItemsFor, swapsFor, system.slots);
    }

    function systemChanged(system) {
        if (system.kind === 'property') return system.selected !== system.storeSelected;
        if (system.kind === 'propertyGroup') return system.slots.some(function (slot) { return Number(slot.selected) !== Number(slot.storeSelected); });
        return system.slots.some(function (slot) { return Number(slot.modelId) !== Number(slot.storeModelId); });
    }

    function slotOptionById(slot, id) {
        return (slot.options || []).find(function (option) { return Number(option.id) === Number(id); }) || null;
    }

    function slotValueLabel(slot) {
        var option = slotOptionById(slot, slot.selected);
        if (option) return option.label;
        return slot.storeLabel || N_('NOT SPECIFIED');
    }

    function modelSlotName(slot) {
        var swap = swapByModel(slot.categoryId, slot.modelId);
        return String((swap ? swap.model_name : slot.storeModelName) || '').trim();
    }

    function optionById(system, id) {
        return (system.options || []).find(function (option) { return Number(option.id) === Number(id); }) || null;
    }

    function compactValue(system) {
        if (system.kind === 'property') {
            var option = optionById(system, system.selected);
            if (!option) {
                if (system.id === 'frets' && system.storeIsFretless) return N_('FRETLESS');
                return system.id === 'neckProfile' && system.disabled ? N_('CUSTOM') : N_('NOT SPECIFIED');
            }
            if (system.id === 'frets') return fretCountValue(option.label) + ' · ' + fretMaterialLabel(option.label);
            if (system.id === 'scale') return /24\.75/.test(option.label) ? N_('SHORT · 24.75″') : N_('LONG · 25.5″');
            return option.label;
        }
        if (system.kind === 'propertyGroup') {
            if (system.presetOptions) return String(presetValue(system)).toUpperCase();
            return slotValueLabel(system.slots[0]).toUpperCase();
        }
        if (system.kind === 'model') return modelSlotName(system.slots[0]).replace(/\s*Electronics$/i, '').toUpperCase();
        var pack = matchingPack(system);
        if (pack) return String(pack.pack_name).replace(/\s*FX Pack$/i, '').replace(/\s*Pack$/i, '').toUpperCase();
        return N_('CUSTOM');
    }

    function compactExtra(system) {
        if (system.kind === 'propertyGroup') {
            if (system.presetOptions) return '';
            return system.slots.slice(1).map(slotValueLabel).join(' · ');
        }
        if (system.kind !== 'pack') return '';
        if (system.packType === 'pickup') {
            return system.slots.slice().reverse().map(function (slot) {
                var swap = swapByModel(slot.categoryId, slot.modelId);
                var name = swap ? swap.model_name : slot.storeModelName;
                var component = pickupComponentMeta(name, slot.categoryId);
                return component.key;
            }).join(' + ');
        }
        return system.slots.map(function (slot) {
            var swap = swapByModel(slot.categoryId, slot.modelId);
            return fxCodeOf(swap ? swap.model_name : slot.storeModelName) || '—';
        }).join(' + ');
    }

    function committedDelta() {
        return overridesItems().reduce(function (sum, item) { return sum + (Number(item.delta_price) || 0); }, 0);
    }

    function optionPriceMarkup(delta) {
        return '<span class="config-option-price' + deltaClass(delta) + '" data-price-domain="designerBuild" data-price-status="' + (delta == null ? 'unresolved' : 'calculated-delta') + '">' + esc(deltaText(delta)) + '</span>';
    }

    function profileThumb(name, section) {
        var record = profileMetaFor(name);
        var asset = record && record.assets && record.assets[section === 'zero' ? 'thumb0' : 'thumb12'];
        return asset ? CDN + asset : '';
    }

    function profileFull(name) {
        var record = profileMetaFor(name);
        var asset = record && record.assets && record.assets.full;
        return asset ? '<img src="' + esc(CDN + asset) + '" alt="' + esc(name + ' dimensioned neck-profile drawing') + '">' : '<span class="neck-option-missing">' + N_('Detailed drawing unavailable') + '</span>';
    }

    function profileImageMarkup(name, section, extra) {
        var url = profileThumb(name, section);
        var alt = name + ' profile at ' + (section === 'zero' ? '0th' : '12th') + ' fret' + (url ? '' : ' (preview unavailable)');
        return '<img ' + (url ? 'src="' + esc(url) + '"' : 'data-missing-asset="true"') + ' alt="' + esc(alt) + '" ' + (extra || '') + '>';
    }

    function profileNameFitSize(value) {
        var length = String(value || '').length;
        return length > 24 ? '9px' : length > 18 ? '10.5px' : length > 14 ? '12px' : '13px';
    }

    function currentProfileName() {
        var system = systems.find(function (candidate) { return candidate.id === 'neckProfile'; });
        if (!system) return '';
        var option = optionById(system, system.selected);
        if (option) return option.label;
        var data = getSrvData();
        var row = data && neckPropertyByParent(data, 2);
        return system.disabled ? (row ? String(row.design_part_property_value || N_('Custom profile')) : N_('Custom profile')) : N_('Not specified');
    }

    function foundationMarkup() {
        var readouts = systems.filter(function (system) { return system.id !== 'neckProfile'; });
        var profileSystem = systems.find(function (system) { return system.id === 'neckProfile'; });
        var changeCue = '<span class="config-change-cue" aria-hidden="true"><i class="fa-solid fa-pen-ruler"></i><span>CHANGE</span></span>';
        var readoutHtml = readouts.map(function (system, position) {
            var index = systems.indexOf(system);
            return '<button type="button" class="build-readout-item' + (systemChanged(system) ? ' is-config-modified' : '') + '" data-config-open-index="' + index + '" data-config-family="' + esc(system.id) + '" data-description="' + esc(system.description) + '" title="' + esc(system.description) + '" aria-haspopup="dialog" aria-label="' + esc(__('{0}. Current selection {1}', __(system.label), __(compactValue(system)))) + '">' + changeCue + '<span class="build-readout-content"><span class="build-readout-copy"><span class="build-readout-title">' + esc(system.readoutLabel) + '</span><span class="build-readout-value"><span data-readout-main="' + index + '">' + esc(compactValue(system)) + '</span><small data-readout-extra="' + index + '">' + esc(compactExtra(system)) + '</small></span></span></span></button>';
        }).join('');
        var profileHtml = '';
        if (profileSystem) {
            var profileIndex = systems.indexOf(profileSystem);
            var profileName = currentProfileName();
            var note = profileSystem.disabled ? profileSystem.disabledNote : profileSystem.description;
            var hasThumbs = !!profileThumb(profileName, 'zero');
            var thumbsHtml = hasThumbs
                ? '<figure class="profile-shape-thumbnail" aria-label="' + esc(__('{0} profile sections', profileName)) + '"><div class="profile-shape-section">' + profileImageMarkup(profileName, 'zero', 'data-profile-zero') + '<figcaption class="profile-shape-title">0 FRET</figcaption></div><div class="profile-shape-section">' + profileImageMarkup(profileName, 'twelfth', 'data-profile-twelfth') + '<figcaption class="profile-shape-title">12 FRET</figcaption></div></figure>'
                : '<p class="profile-shape-note">' + esc(profileSystem.disabled ? N_('Custom-shaped neck profile. The dimensioned drawing lives in the 3D Designer.') : N_('Profile drawing unavailable.')) + '</p>';
            profileHtml = '<div class="profile-shape-wrap' + (systemChanged(profileSystem) ? ' is-config-modified' : '') + '" data-description="' + esc(note) + '"><button type="button" class="profile-config-hit" data-config-open-index="' + profileIndex + '" title="' + esc(note) + '" aria-haspopup="dialog" aria-label="' + esc(__('Neck Profile. Current selection {0}', profileName)) + '">' + changeCue + '</button><div class="profile-shape-meta"><span class="build-readout-title">' + esc(profileSystem.readoutLabel || N_('PROFILE')) + '</span><span class="profile-meta-line" aria-hidden="true"></span><span class="profile-shape-name" data-profile-name style="--profile-fit-size:' + profileNameFitSize(profileName) + '">' + esc(profileName) + '</span></div>' + thumbsHtml + '</div>';
        }
        return '<div class="foundation-shell"><div class="foundation-layout' + (profileHtml ? '' : ' foundation-layout--flat') + '"><div class="build-readout build-readout--' + readouts.length + '" aria-label="Current build configuration">' + readoutHtml + '</div>' + profileHtml + '</div></div>';
    }

    function workingSystems() { return draft || systems; }

    function cloneSystems(source) {
        return source.map(function (system) {
            var copy = Object.assign({}, system);
            if (system.slots) copy.slots = system.slots.map(function (slot) { return Object.assign({}, slot); });
            return copy;
        });
    }

    function draftChanged() {
        if (!draft) return false;
        return JSON.stringify(comparable(draft)) !== JSON.stringify(comparable(systems));
    }

    function comparable(list) {
        return list.map(function (system) {
            return { id: system.id, selected: system.selected, slots: (system.slots || []).map(function (slot) { return slot.modelId != null ? 'm' + slot.modelId : 's' + slot.selected; }) };
        });
    }

    function updateCommitState() {
        var changed = draftChanged();
        if (applyButton) applyButton.disabled = !changed;
        if (commitStatus) commitStatus.textContent = changed ? N_('Changes ready to apply') : N_('No pending changes');
    }

    function fretOptionFor(system, count, material) {
        return (system.options || []).find(function (option) {
            return fretCountValue(option.label) === count && fretMaterialLabel(option.label) === material;
        }) || null;
    }

    function fretChoiceMarkup(system, index) {
        if (system.disabled) {
            return '<section class="config-section focused-config-section fret-choice-stage"><div class="config-stage-heading">FRETS</div><p class="neck-option-missing">' + esc(system.disabledNote || N_('Fret configuration is managed in the 3D Designer.')) + '</p></section>';
        }
        var counts = [];
        (system.options || []).forEach(function (option) {
            var count = fretCountValue(option.label);
            if (count && counts.indexOf(count) < 0) counts.push(count);
        });
        counts.sort();
        var selectedOption = optionById(system, system.selected);
        var selectedCount = fretCountDraft || (selectedOption && fretCountValue(selectedOption.label)) || counts[0] || '';
        var materials = ['S.STEEL', 'TITANIUM'].filter(function (material) { return !!fretOptionFor(system, selectedCount, material); });
        var countHtml = counts.map(function (count) {
            var selected = count === selectedCount;
            var description = count + ' individually adjustable fret positions.';
            return '<button type="button" role="radio" tabindex="' + (selected ? '0' : '-1') + '" class="config-option fret-count-option' + (selected ? ' selected' : '') + '" data-fret-count="' + esc(count) + '" data-help-title="' + esc(count + ' FRETS') + '" data-description="' + esc(description) + '" aria-checked="' + selected + '" aria-label="' + esc(__('Choose {0} frets', count)) + '"><strong class="config-option-hero">' + esc(count) + '</strong><span class="config-option-detail">FRETS</span></button>';
        }).join('');
        var materialHtml = materials.map(function (material) {
            var option = fretOptionFor(system, selectedCount, material);
            var selected = !!selectedOption && option.id === selectedOption.id;
            return '<div class="config-choice-unit"><button type="button" role="radio" tabindex="' + (selected ? '0' : '-1') + '" class="config-option' + (selected ? ' selected' : '') + (option.id === system.storeSelected ? ' is-store-default' : '') + '" data-config-index="' + index + '" data-config-option="' + option.id + '" data-help-title="' + esc(material) + '" data-description="' + esc(option.description) + '" aria-checked="' + selected + '" aria-label="' + esc(material + '. ' + option.description + ' ' + deltaText(option.delta)) + '"><strong class="config-option-hero fret-material-name">' + esc(material) + '</strong><span class="config-option-detail">' + N_('MATERIAL') + '</span></button>' + optionPriceMarkup(option.delta) + '</div>';
        }).join('');
        return '<section class="config-section focused-config-section fret-choice-stage fret-combined-stage" aria-label="' + N_('Choose fret count and material') + '"><div class="config-stage-heading">' + N_('SELECT FRETS') + '</div><section class="fret-property-group" role="radiogroup" aria-label="' + N_('Fret count') + '"><div class="fret-property-label">FRET COUNT</div><div class="fret-stage-grid fret-count-grid has-selection">' + countHtml + '</div></section><section class="fret-property-group" role="radiogroup" aria-label="' + N_('Fret material') + '"><div class="fret-property-label">' + N_('FRET MATERIAL') + '</div><div class="config-option-grid fret-stage-grid fret-material-grid has-selection">' + materialHtml + '</div></section></section>';
    }

    function profileSelectorMarkup(system, index) {
        var selectedOption = optionById(system, system.selected);
        var selectedName = selectedOption ? selectedOption.label : currentProfileName();
        var listHtml = (system.options || []).map(function (option) {
            var selected = !!selectedOption && option.id === selectedOption.id;
            var disabled = !!system.disabled;
            return '<button type="button" role="radio" tabindex="' + (selected ? '0' : '-1') + '" class="neck-profile-list-option' + (selected ? ' selected' : '') + (option.id === system.storeSelected ? ' is-store-default' : '') + '" data-config-index="' + index + '" data-config-option="' + option.id + '" data-help-title="' + esc(option.label) + '" data-description="' + esc(option.description) + '" aria-checked="' + selected + '" aria-disabled="' + disabled + '"' + (disabled ? ' disabled' : '') + ' aria-label="' + esc(option.label + '. ' + option.description + ' ' + deltaText(option.delta)) + '"><span>' + esc(option.label) + '</span>' + optionPriceMarkup(option.delta) + '</button>';
        }).join('');
        var activeDescription = system.disabled ? system.disabledNote : ((selectedOption && selectedOption.description) || '');
        var activePrice = selectedOption ? optionPriceMarkup(selectedOption.delta) : '';
        return '<section class="config-section focused-config-section neck-profile-selector" aria-label="' + N_('Choose neck profile') + '"><div class="neck-profile-layout"><div class="neck-profile-list has-selection" role="radiogroup" aria-label="' + N_('Available neck profiles') + '">' + listHtml + '</div><aside class="neck-profile-live-preview" aria-live="polite"><div class="neck-profile-preview-art">' + profileFull(selectedName) + '</div><div class="neck-profile-preview-copy"><span>' + N_('SELECTED PROFILE') + '</span><h3>' + esc(selectedName) + '</h3><p>' + esc(activeDescription) + '</p>' + activePrice + '</div></aside></div></section>';
    }

    function genericGridMarkup(system, index) {
        var optionsHtml = (system.options || []).map(function (option) {
            var selected = Number(option.id) === Number(system.selected);
            var hero = option.label;
            var detail = '';
            if (system.id === 'scale') {
                hero = /24\.75/.test(option.label) ? N_('SHORT') : N_('LONG');
                detail = /24\.75/.test(option.label) ? '24.75″' : '25.5″';
            }
            var fit = heroFitSize(hero);
            return '<div class="config-choice-unit"><button type="button" role="radio" tabindex="' + (selected ? '0' : '-1') + '" class="config-option' + (selected ? ' selected' : '') + (option.id === system.storeSelected ? ' is-store-default' : '') + '" data-config-index="' + index + '" data-config-option="' + option.id + '" data-help-title="' + esc(option.label) + '" data-description="' + esc(option.description) + '" aria-checked="' + selected + '" aria-label="' + esc(option.label + '. ' + option.description + ' ' + deltaText(option.delta)) + '"><strong class="config-option-hero"' + (fit ? ' style="--config-hero-fit:' + fit + '"' : '') + '>' + esc(hero) + '</strong>' + (detail ? '<span class="config-option-detail">' + esc(detail) + '</span>' : '') + '</button>' + optionPriceMarkup(option.delta) + '</div>';
        }).join('');
        return '<section class="config-section focused-config-section" role="radiogroup" aria-label="' + esc(__('Choose {0}', __(system.label))) + '"><div class="config-option-grid has-selection">' + optionsHtml + '</div></section>';
    }

    function subpanelHead(label) {
        return '<header class="config-subpanel-head"><button type="button" class="config-subpanel-back" data-config-back aria-label="' + N_('Back to current selection') + '"><i class="fa-solid fa-arrow-left" aria-hidden="true"></i><span>BACK</span></button><strong>' + esc(label) + '</strong><span aria-hidden="true"></span></header>';
    }

    function engravingMark(record, categoryId) {
        var asset = record && record.engraving && record.engraving.asset;
        if (!asset) return '';
        var side = categoryId === PICKUP_CATS.neck ? 'neck' : 'bridge';
        return '<i class="config-pickup-engraving is-' + side + '" style="--config-pickup-engraving:url(&quot;' + esc(CDN + asset) + '&quot;)" aria-hidden="true"></i>';
    }

    function slotDisplay(system, slot) {
        var swap = swapByModel(slot.categoryId, slot.modelId);
        var name = swap ? swap.model_name : slot.storeModelName;
        if (system.packType === 'pickup') {
            var component = pickupComponentMeta(name, slot.categoryId);
            var output = (component.record && component.record.outputClass) || outputFromName(name) || '';
            return { name: component.key, detail: output, description: (component.record && component.record.description) || '', record: component.record };
        }
        var code = fxCodeOf(name) || '—';
        var card = (meta().fx_card || {})[code];
        var clean = String(name || '').replace(/\s*\([^)]*\)\s*/g, '').replace(new RegExp('\\b' + code + '\\b', 'i'), '').trim();
        return { name: (card && card.canonicalName ? String(card.canonicalName).replace(code, '').trim() : clean) || code, detail: code, description: (card && card.description) || '', record: card };
    }

    function packStatusMarkup(system, index) {
        var pack = matchingPack(system);
        var intact = !!pack;
        var packTitle = intact ? String(pack.pack_name).toUpperCase() : N_('CUSTOM');
        var packDetail = intact ? (pack.pack_description || '') : (system.packType === 'pickup' ? N_('INDIVIDUAL PICKUP SELECTION') : N_('INDIVIDUAL CARD SELECTION'));
        var expandKey = system.packType === 'pickup' ? 'pickup-options' : 'fx-packs';
        var slotKey = system.packType === 'pickup' ? 'pickup-slot' : 'fx-slot';
        var slotsHtml = system.slots.map(function (slot) {
            var display = slotDisplay(system, slot);
            var mark = system.packType === 'pickup' ? engravingMark(display.record, slot.categoryId) : '';
            var body = system.packType === 'pickup'
                ? mark + '<strong>' + esc(display.name) + '</strong><small>' + esc(display.detail) + '</small>'
                : '<strong class="config-status-module-code">' + esc(display.detail) + '</strong><span class="config-status-module-name">' + String(display.name).toUpperCase().split(/\s+/).map(function (word) { return '<span>' + esc(word) + '</span>'; }).join('') + '</span>';
            return '<div class="config-status-slot"><span class="config-status-slot-label">' + esc(slot.label) + '</span><button type="button" class="config-status-pedal ' + (system.packType === 'pickup' ? 'config-status-pickup' : 'config-status-fx-module') + '" data-config-expand="' + slotKey + '" data-config-slot="' + esc(slot.id) + '" data-help-title="' + esc(display.name + ' · ' + display.detail) + '" data-description="' + esc(display.description) + '" aria-label="' + esc('Change ' + slot.label + '. Current ' + display.name) + '">' + body + '</button></div>';
        }).join('');
        return '<section class="config-current-status ' + (system.packType === 'pickup' ? 'config-current-status--pickup' : 'config-current-status--fx') + ' ' + (intact ? 'is-intact' : 'is-custom') + '"><div class="config-fx-pack-assembly' + (system.packType === 'pickup' ? ' config-pickup-pair-assembly' : '') + '"><button type="button" class="config-status-card ' + (system.packType === 'pickup' ? 'config-status-card--pickup' : 'config-status-card--pack') + '" data-config-expand="' + expandKey + '" data-help-title="' + esc(packTitle) + '" data-description="' + esc(packDetail) + '" aria-label="' + esc('Change ' + system.label + '. Current selection ' + packTitle) + '"><strong>' + esc(packTitle) + '</strong><span>' + esc(system.packType === 'pickup' ? packDetail : '') + '</span><small>' + (system.packType === 'pickup' ? N_('EDIT PRESET PAIR') : N_('EDIT PRESET PACK')) + '</small></button><div class="config-status-pedals ' + (system.packType === 'pickup' ? 'config-status-pickups' : 'config-status-fx-modules') + '">' + slotsHtml + '</div></div></section>';
    }

    function packChoicesMarkup(system, index) {
        var current = matchingPack(system);
        var packsHtml = system.packs.map(function (pack) {
            var selected = !!current && Number(current.pack_id) === Number(pack.pack_id);
            var delta = pack.delta_price == null ? null : Number(pack.delta_price);
            var copy = findCopy(system.id, packCopyCandidates(pack.pack_name));
            var description = pack.pack_description || (copy && copy.description) || '';
            var detail = packItemsFor(pack.pack_id).map(function (item) {
                return system.packType === 'pickup' ? pickupComponentMeta(item.model_name, Number(item.category_id) === PICKUP_CATS.neck ? PICKUP_CATS.neck : PICKUP_CATS.bridge).key : (fxCodeOf(item.model_name) || item.model_name);
            }).join(' · ');
            var shortName = String(pack.pack_name).replace(/\s*FX Pack$/i, '').replace(/\s*Pack$/i, '');
            var nameParts = shortName.split(/\s+/);
            var hero = nameParts.shift().toUpperCase();
            var qualifier = nameParts.join(' ').toUpperCase();
            return '<div class="config-choice-unit"><button type="button" role="radio" tabindex="' + (selected ? '0' : '-1') + '" class="config-option' + (selected ? ' selected' : '') + '" data-config-pack="' + pack.pack_id + '" data-config-index="' + index + '" data-help-title="' + esc(pack.pack_name) + '" data-description="' + esc(description) + '" aria-checked="' + selected + '" aria-label="' + esc(pack.pack_name + '. ' + description + ' ' + deltaText(delta)) + '"><strong class="config-option-hero pack-option-hero">' + esc(hero) + '</strong>' + (qualifier ? '<span class="config-option-detail pack-option-qualifier">' + esc(qualifier) + '</span>' : '') + '<span class="config-option-detail pack-option-components">' + esc(detail) + '</span></button>' + optionPriceMarkup(delta) + '</div>';
        }).join('');
        return '<section class="config-section focused-config-section" role="radiogroup" aria-label="' + esc(__('Choose {0}', __(system.label))) + '">' + subpanelHead(system.packType === 'pickup' ? N_('PICKUP SETS') : N_('FX PACKS')) + '<div class="config-option-grid has-selection">' + packsHtml + '</div></section>';
    }

    function slotBuilderMarkup(system, index, slotId) {
        var slot = system.slots.find(function (candidate) { return candidate.id === slotId; }) || system.slots[0];
        var display = slotDisplay(system, slot);
        var choicesHtml = swapsFor(slot.categoryId).map(function (swap) {
            var selected = Number(swap.model_id) === Number(slot.modelId);
            var isDefault = Number(swap.model_id) === Number(slot.storeModelId);
            var delta = swap.delta_price == null ? null : Number(swap.delta_price);
            var body;
            var help;
            var description;
            if (system.packType === 'pickup') {
                var component = pickupComponentMeta(swap.model_name, slot.categoryId);
                var output = (component.record && component.record.outputClass) || outputFromName(swap.model_name);
                description = (component.record && component.record.description) || '';
                help = component.key + ' · ' + output;
                body = engravingMark(component.record, slot.categoryId) + '<strong>' + esc(component.key) + '</strong><span>' + esc(output) + '</span>';
            } else {
                var code = fxCodeOf(swap.model_name);
                var card = (meta().fx_card || {})[code];
                var cardName = (card && String(card.canonicalName).replace(code, '').trim()) || String(swap.model_name).replace(/\s*\([^)]*\)\s*/g, '');
                description = (card && card.description) || '';
                help = cardName + ' · ' + code;
                body = '<strong>' + esc(cardName) + '</strong><span>' + esc(code) + '</span>';
            }
            return '<button type="button" role="radio" tabindex="' + (selected ? '0' : '-1') + '" class="fx-slot-choice' + (system.packType === 'pickup' ? ' pickup-slot-choice' : '') + (selected ? ' selected' : '') + (isDefault ? ' is-store-default' : '') + (selected && !isDefault ? ' is-modified' : '') + '" data-slot-model="' + swap.model_id + '" data-slot-base-price="' + esc(swap.model_base_price) + '" data-config-index="' + index + '" data-config-slot="' + esc(slot.id) + '" data-help-title="' + esc(help) + '" data-description="' + esc(description) + '" aria-checked="' + selected + '" aria-label="' + esc(slot.label + '. ' + help + '. ' + description + ' ' + deltaText(delta)) + '">' + body + optionPriceMarkup(delta) + '</button>';
        }).join('');
        return '<section class="fx-config-builder fx-config-builder--single' + (system.packType === 'pickup' ? ' pickup-config-builder' : '') + '" aria-label="' + esc(__('Choose {0}', __(slot.label))) + '">' + subpanelHead(slot.label + ' · ' + display.name) + '<div class="fx-single-slot-grid' + (system.packType === 'pickup' ? ' pickup-single-slot-grid' : '') + ' has-selection" role="radiogroup" aria-label="' + esc(slot.label) + '">' + choicesHtml + '</div></section>';
    }

    function swatchMarkup(option) {
        if (!option || !option.hex) return '';
        return '<span class="config-swatch" style="background:' + esc(option.hex) + '" aria-hidden="true"></span>';
    }

    function propertyGroupStatusMarkup(system, index) {
        var slotsHtml = system.slots.map(function (slot) {
            var option = slotOptionById(slot, slot.selected);
            var changed = Number(slot.selected) !== Number(slot.storeSelected);
            var value = slotValueLabel(slot);
            return '<div class="config-status-slot"><span class="config-status-slot-label">' + esc(slot.label) + '</span><button type="button" class="config-status-pedal config-status-property' + (changed ? ' is-modified' : '') + '" data-config-expand="prop-slot" data-config-slot="' + esc(slot.id) + '" data-help-title="' + esc(slot.label) + '" data-description="' + esc((option && option.description) || system.description) + '" aria-label="' + esc('Change ' + slot.label + '. Current ' + value) + '">' + swatchMarkup(option) + '<strong>' + esc(value) + '</strong></button></div>';
        }).join('');
        return '<section class="config-current-status config-current-status--property is-intact"><div class="config-status-pedals">' + slotsHtml + '</div></section>';
    }

    function propertySlotMarkup(system, index, slotId) {
        var slot = system.slots.find(function (candidate) { return candidate.id === slotId; }) || system.slots[0];
        var optionsHtml = (slot.options || []).map(function (option) {
            var selected = Number(option.id) === Number(slot.selected);
            var isDefault = Number(option.id) === Number(slot.storeSelected);
            return '<button type="button" role="radio" tabindex="' + (selected ? '0' : '-1') + '" class="config-property-option' + (selected ? ' selected' : '') + (isDefault ? ' is-store-default' : '') + (selected && !isDefault ? ' is-modified' : '') + '" data-prop-option="' + option.id + '" data-config-index="' + index + '" data-config-slot="' + esc(slot.id) + '" data-help-title="' + esc(option.label) + '" data-description="' + esc(option.description) + '" aria-checked="' + selected + '" aria-label="' + esc(option.label + '. ' + deltaText(option.delta)) + '"><span class="config-property-face">' + swatchMarkup(option) + '<span class="config-property-name">' + esc(option.label) + '</span></span>' + optionPriceMarkup(option.delta) + '</button>';
        }).join('');
        var head = system.slots.length > 1 ? subpanelHead(slot.label) : '';
        var hasSelection = !!slotOptionById(slot, slot.selected);
        return '<section class="config-section focused-config-section config-property-stage" aria-label="' + esc(__('Choose {0}', __(slot.label))) + '">' + head + '<div class="config-property-list' + (hasSelection ? ' has-selection' : '') + '" role="radiogroup" aria-label="' + esc(slot.label) + '">' + optionsHtml + '</div></section>';
    }

    function presetListMarkup(system, index) {
        var current = presetValue(system);
        var optionsHtml = (system.presetOptions || []).map(function (option) {
            var selected = option.label === current;
            var isDefault = system.slots.every(function (slot) { return Number(option.perSlot[slot.id]) === Number(slot.storeSelected); });
            return '<button type="button" role="radio" tabindex="' + (selected ? '0' : '-1') + '" class="config-property-option' + (selected ? ' selected' : '') + (isDefault ? ' is-store-default' : '') + (selected && !isDefault ? ' is-modified' : '') + '" data-preset-option="' + esc(option.label) + '" data-config-index="' + index + '" data-help-title="' + esc(option.label) + '" data-description="' + esc(option.description) + '" aria-checked="' + selected + '" aria-label="' + esc(option.label + '. ' + deltaText(option.delta)) + '"><span class="config-property-face">' + swatchMarkup(option) + '<span class="config-property-name">' + esc(option.label) + '</span></span>' + optionPriceMarkup(option.delta) + '</button>';
        }).join('');
        return '<section class="config-section focused-config-section config-property-stage" aria-label="' + esc(__('Choose {0}', __(system.label))) + '"><div class="config-property-list' + (presetOptionByLabel(system, current) ? ' has-selection' : '') + '" role="radiogroup" aria-label="' + esc(system.label) + '">' + optionsHtml + '</div></section>';
    }

    function propertyListMarkup(system, index) {
        var optionsHtml = (system.options || []).map(function (option) {
            var selected = Number(option.id) === Number(system.selected);
            var isDefault = Number(option.id) === Number(system.storeSelected);
            return '<button type="button" role="radio" tabindex="' + (selected ? '0' : '-1') + '" class="config-property-option' + (selected ? ' selected' : '') + (isDefault ? ' is-store-default' : '') + (selected && !isDefault ? ' is-modified' : '') + '" data-config-option="' + option.id + '" data-config-index="' + index + '" data-help-title="' + esc(option.label) + '" data-description="' + esc(option.description) + '" aria-checked="' + selected + '" aria-label="' + esc(option.label + '. ' + deltaText(option.delta)) + '"><span class="config-property-face">' + swatchMarkup(option) + '<span class="config-property-name">' + esc(option.label) + '</span></span>' + optionPriceMarkup(option.delta) + '</button>';
        }).join('');
        var hasSelection = !!optionById(system, system.selected);
        return '<section class="config-section focused-config-section config-property-stage" aria-label="' + esc(__('Choose {0}', __(system.label))) + '"><div class="config-property-list' + (hasSelection ? ' has-selection' : '') + '" role="radiogroup" aria-label="' + esc(system.label) + '">' + optionsHtml + '</div></section>';
    }

    // Hex tiles only hold a couple of short words. Anything longer (or a colour list)
    // reads as a swatch list instead of overflowing its frame.
    function wantsListLayout(system) {
        var options = system.options || [];
        if (options.length > 6) return true;
        if (options.some(function (option) { return !!option.hex; })) return true;
        return options.some(function (option) { return String(option.label).length > 14; });
    }

    function heroFitSize(label) {
        var length = String(label || '').length;
        if (length > 13) return '15px';
        if (length > 10) return '19px';
        if (length > 7) return '24px';
        return '';
    }

    function modelGridMarkup(system, index) {
        var slot = system.slots[0];
        var optionsHtml = swapsFor(slot.categoryId).map(function (swap) {
            var selected = Number(swap.model_id) === Number(slot.modelId);
            var isDefault = Number(swap.model_id) === Number(slot.storeModelId);
            var delta = swap.delta_price == null ? null : Number(swap.delta_price);
            var name = String(swap.model_name || '').trim();
            var hero = name.replace(/\s*Electronics$/i, '');
            var detail = /electronics/i.test(name) ? N_('ELECTRONICS') : '';
            var fitModel = heroFitSize(hero);
            return '<div class="config-choice-unit"><button type="button" role="radio" tabindex="' + (selected ? '0' : '-1') + '" class="config-option' + (selected ? ' selected' : '') + (isDefault ? ' is-store-default' : '') + '" data-model-option="' + swap.model_id + '" data-config-index="' + index + '" data-help-title="' + esc(name) + '" data-description="' + esc(system.description) + '" aria-checked="' + selected + '" aria-label="' + esc(name + '. ' + deltaText(delta)) + '"><strong class="config-option-hero"' + (fitModel ? ' style="--config-hero-fit:' + fitModel + '"' : '') + '>' + esc(hero.toUpperCase()) + '</strong>' + (detail ? '<span class="config-option-detail">' + esc(detail) + '</span>' : '') + '</button>' + optionPriceMarkup(delta) + '</div>';
        }).join('');
        return '<section class="config-section focused-config-section" role="radiogroup" aria-label="' + esc(__('Choose {0}', __(system.label))) + '"><div class="config-option-grid has-selection">' + optionsHtml + '</div></section>';
    }

    function familyMarkup(system, index) {
        if (system.kind === 'property') {
            if (system.id === 'frets') return fretChoiceMarkup(system, index);
            if (system.id === 'neckProfile') return profileSelectorMarkup(system, index);
            if (system.id !== 'scale' && wantsListLayout(system)) return propertyListMarkup(system, index);
            return genericGridMarkup(system, index);
        }
        if (system.kind === 'propertyGroup') {
            if (system.presetOptions) return presetListMarkup(system, index);
            if (choiceView === 'prop-slot') return propertySlotMarkup(system, index, choiceSlot);
            return propertyGroupStatusMarkup(system, index);
        }
        if (system.kind === 'model') return modelGridMarkup(system, index);
        if (choiceView === 'pickup-options' || choiceView === 'fx-packs') return packChoicesMarkup(system, index);
        if (choiceView === 'pickup-slot' || choiceView === 'fx-slot') return slotBuilderMarkup(system, index, choiceSlot);
        return packStatusMarkup(system, index);
    }

    function updateHelp(control, system) {
        system = system || workingSystems()[currentFamily];
        var fallbackTitle = system.kind === 'property' ? (optionById(system, system.selected) || {}).label : compactValue(system);
        var title = (control && control.dataset.helpTitle) || fallbackTitle || N_('Current selection');
        var copy = (control && control.dataset.description) || system.description || '';
        if (helpTitle) helpTitle.textContent = title;
        if (helpCopy) helpCopy.textContent = copy || N_('Choose an option to compare its playing character.');
    }

    function showHelp(control) {
        if (!control || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        updateHelp(control);
        var rect = control.getBoundingClientRect();
        var helpWidth = Math.min(380, window.innerWidth - 28);
        var x = Math.max(helpWidth / 2 + 14, Math.min(window.innerWidth - helpWidth / 2 - 14, rect.left + rect.width / 2));
        var above = rect.bottom + 130 > window.innerHeight;
        overlay.style.setProperty('--config-help-x', x + 'px');
        overlay.style.setProperty('--config-help-y', (above ? rect.top - 12 : rect.bottom + 12) + 'px');
        overlay.classList.toggle('help-above', above);
        overlay.classList.add('has-active-help');
    }

    function renderFocusedFamily() {
        var system = workingSystems()[currentFamily];
        if (!system) return;
        dialogTitle.textContent = system.label;
        dialogExplanation.textContent = system.disabled ? system.disabledNote : (system.description || N_('Choose one part of the build.'));
        overlay.dataset.family = system.label.toLowerCase().replace(/\s+/g, '-');
        overlay.dataset.view = choiceView;
        overlay.classList.remove('has-active-help', 'help-above');
        dialogBody.innerHTML = familyMarkup(system, currentFamily);
        var selectedControl = dialogBody.querySelector('.neck-profile-list-option.selected');
        if (selectedControl) selectedControl.scrollIntoView({ block: 'nearest' });
        updateHelp(dialogBody.querySelector('[aria-checked="true"],[data-config-expand]'), system);
        updateCommitState();
    }

    function announce(text) { if (choiceSr) choiceSr.textContent = text; }

    function chooseProperty(index, propertyId) {
        var system = workingSystems()[index];
        if (!system || system.kind !== 'property' || system.disabled) return;
        var option = optionById(system, propertyId);
        if (!option) return;
        system.selected = Number(propertyId);
        announce(system.label + ' selection: ' + option.label + '. ' + deltaText(option.delta));
        renderFocusedFamily();
    }

    function chooseSlotProperty(index, slotId, propertyId) {
        var system = workingSystems()[index];
        if (!system || system.kind !== 'propertyGroup') return;
        var slot = system.slots.find(function (candidate) { return candidate.id === slotId; });
        if (!slot) return;
        var option = slotOptionById(slot, propertyId);
        if (!option) return;
        slot.selected = Number(propertyId);
        announce(slot.label + ' selection: ' + option.label + '. ' + deltaText(option.delta));
        renderFocusedFamily();
    }

    function choosePreset(index, label) {
        var system = workingSystems()[index];
        if (!system || system.kind !== 'propertyGroup' || !system.presetOptions) return;
        var option = presetOptionByLabel(system, label);
        if (!option) return;
        system.slots.forEach(function (slot) {
            if (option.perSlot[slot.id] != null) slot.selected = Number(option.perSlot[slot.id]);
        });
        announce(system.label + ' selection: ' + option.label + '. ' + deltaText(option.delta));
        renderFocusedFamily();
    }

    function chooseModel(index, modelId) {
        var system = workingSystems()[index];
        if (!system || system.kind !== 'model') return;
        var slot = system.slots[0];
        slot.modelId = Number(modelId);
        announce(system.label + ' selection: ' + modelSlotName(slot) + '.');
        renderFocusedFamily();
    }

    function choosePack(index, packId) {
        var system = workingSystems()[index];
        if (!system || system.kind !== 'pack') return;
        var items = packItemsFor(packId);
        system.slots.forEach(function (slot) {
            var item = items.find(function (candidate) { return Number(candidate.category_id) === slot.categoryId; });
            if (!item) return;
            var swap = swapsFor(slot.categoryId).find(function (candidate) { return candidate.model_name === item.model_name || Number(candidate.model_id) === Number(item.model_id); });
            if (item.model_id != null) slot.modelId = Number(item.model_id);
            else if (swap) slot.modelId = Number(swap.model_id);
        });
        var pack = system.packs.find(function (candidate) { return Number(candidate.pack_id) === Number(packId); });
        announce(system.label + ' selection: ' + (pack ? pack.pack_name : 'pack') + '.');
        choiceView = 'status';
        choiceSlot = '';
        renderFocusedFamily();
    }

    function chooseSlotModel(index, slotId, modelId) {
        var system = workingSystems()[index];
        if (!system || system.kind !== 'pack') return;
        var slot = system.slots.find(function (candidate) { return candidate.id === slotId; });
        if (!slot) return;
        slot.modelId = Number(modelId);
        var display = slotDisplay(system, slot);
        announce(slot.label + ' selection: ' + display.name + '.');
        choiceView = 'status';
        choiceSlot = '';
        renderFocusedFamily();
    }

    function applyDraft() {
        if (!draft) return;
        draft.forEach(function (draftSystem, index) {
            // systems is rebuilt by buildSystems() on every apply and reset, and a family whose
            // group went missing is dropped, so positions do not survive. Match on id.
            var committed = systems.find(function (system) { return system.id === draftSystem.id; }) || systems[index];
            if (!committed) return;
            var committedSlotById = function (slot) {
                return (committed.slots || []).find(function (candidate) { return candidate.id === slot.id; }) || null;
            };
            if (draftSystem.kind === 'property') {
                if (draftSystem.selected === committed.selected) return;
                var option = optionById(draftSystem, draftSystem.selected);
                window.setGuitarPropertyOnPart(draftSystem.categoryId, draftSystem.parentId, draftSystem.selected, option ? option.delta : 0);
                if (draftSystem.id === 'frets' && option) syncBodyFretCount(fretCountValue(option.label));
                return;
            }
            if (draftSystem.kind === 'propertyGroup') {
                draftSystem.slots.forEach(function (slot) {
                    var committedSlot = committedSlotById(slot);
                    if (committedSlot && Number(slot.selected) === Number(committedSlot.selected)) return;
                    var option = slotOptionById(slot, slot.selected);
                    window.setGuitarPropertyOnPart(slot.categoryId, slot.parentId, slot.selected, option ? option.delta : 0);
                });
                return;
            }
            if (draftSystem.kind === 'model') {
                var modelSlot = draftSystem.slots[0];
                var committedModelSlot = committedSlotById(modelSlot) || (committed.slots || [])[0];
                if (committedModelSlot && Number(modelSlot.modelId) === Number(committedModelSlot.modelId)) return;
                var modelSwap = swapByModel(modelSlot.categoryId, modelSlot.modelId);
                window.setGuitarModel(modelSlot.categoryId, modelSlot.modelId, modelSwap ? modelSwap.model_base_price : 0);
                return;
            }
            var slotsChanged = draftSystem.slots.some(function (slot) {
                var committedSlot = committedSlotById(slot);
                return !committedSlot || Number(slot.modelId) !== Number(committedSlot.modelId);
            });
            if (!slotsChanged) return;
            var pack = matchingPack(draftSystem);
            if (pack) {
                window.setGuitarPack(draftSystem.packType, pack.pack_id);
                return;
            }
            window.setGuitarPack(draftSystem.packType, '');
            draftSystem.slots.forEach(function (slot) {
                if (Number(slot.modelId) === Number(slot.storeModelId)) return;
                var swap = swapByModel(slot.categoryId, slot.modelId);
                window.setGuitarModel(slot.categoryId, slot.modelId, swap ? swap.model_base_price : 0);
            });
        });
        draft = null;
        systems = buildSystems();
        refreshFoundation();
    }

    function openFamily(index, trigger) {
        var system = systems[index];
        if (!system) return;
        returnFocus = trigger || document.activeElement;
        currentFamily = index;
        choiceView = system.id === 'frets' ? 'fret-combined' : 'status';
        choiceSlot = '';
        if (system.kind === 'propertyGroup' && !system.presetOptions && system.slots.length === 1) {
            choiceView = 'prop-slot';
            choiceSlot = system.slots[0].id;
        }
        var selectedOption = system.kind === 'property' ? optionById(system, system.selected) : null;
        fretCountDraft = system.id === 'frets' && selectedOption ? fretCountValue(selectedOption.label) : '';
        draft = cloneSystems(systems);
        renderFocusedFamily();
        previousOverflow = document.body.style.overflow;
        overlay.inert = false;
        overlay.classList.add('open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        overlay.querySelector('.config-close').focus();
        var openedSelection = dialogBody.querySelector('.neck-profile-list-option.selected');
        if (openedSelection) openedSelection.scrollIntoView({ block: 'nearest' });
    }

    function closeOverlay(apply) {
        if (!overlay.classList.contains('open')) return;
        if (apply) applyDraft(); else draft = null;
        overlay.classList.remove('open');
        overlay.setAttribute('aria-hidden', 'true');
        overlay.inert = true;
        document.body.style.overflow = previousOverflow;
        var target = returnFocus && returnFocus.isConnected && returnFocus.getClientRects().length ? returnFocus : document.getElementById('quick-config-trigger');
        if (target && target.focus) target.focus();
        returnFocus = null;
    }

    function openReset(trigger) {
        resetReturnFocus = trigger || document.activeElement;
        resetPreviousOverflow = document.body.style.overflow;
        resetOverlay.inert = false;
        resetOverlay.classList.add('open');
        resetOverlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        resetOverlay.querySelector('.reset-confirm-cancel').focus();
    }

    function closeReset() {
        if (!resetOverlay.classList.contains('open')) return;
        resetOverlay.classList.remove('open');
        resetOverlay.setAttribute('aria-hidden', 'true');
        resetOverlay.inert = true;
        document.body.style.overflow = resetPreviousOverflow;
        var target = resetReturnFocus && resetReturnFocus.isConnected && resetReturnFocus.getClientRects().length ? resetReturnFocus : document.getElementById('quick-config-trigger');
        if (target && target.focus) target.focus();
        resetReturnFocus = null;
    }

    function restoreStoreBuild() {
        systems.forEach(function (system) {
            if (system.kind === 'property') {
                if (system.selected !== system.storeSelected) window.setGuitarPropertyOnPart(system.categoryId, system.parentId, system.storeSelected == null ? '' : system.storeSelected, 0);
                if (system.id === 'frets') syncBodyFretCount('');
                return;
            }
            if (system.kind === 'propertyGroup') {
                system.slots.forEach(function (slot) {
                    if (Number(slot.selected) === Number(slot.storeSelected)) return;
                    window.setGuitarPropertyOnPart(slot.categoryId, slot.parentId, slot.storeSelected == null ? '' : slot.storeSelected, 0);
                });
                return;
            }
            if (system.kind === 'model') {
                var modelSlot = system.slots[0];
                if (Number(modelSlot.modelId) !== Number(modelSlot.storeModelId)) window.setGuitarModel(modelSlot.categoryId, modelSlot.storeModelId, 0);
                return;
            }
            window.setGuitarPack(system.packType, '');
        });
        systems = buildSystems();
        refreshFoundation();
        announce(N_('Quick Config restored to the original store build.'));
        closeReset();
    }

    function refreshFoundation() {
        var panel = document.getElementById('mobile-config-panel-body');
        if (panel) panel.innerHTML = foundationMarkup();
        var changed = systems.some(systemChanged);
        document.querySelectorAll('[data-quick-config-reset]').forEach(function (reset) {
            reset.style.setProperty('display', changed ? 'inline-flex' : 'none', 'important');
        });
        var delta = committedDelta();
        if (priceChange) {
            priceChange.textContent = delta === 0 ? '' : deltaText(delta);
            priceChange.className = 'config-price-change' + deltaClass(delta) + (delta !== 0 ? ' visible' : '');
        }
        if (typeof window.initItemV10Specs === 'function') window.initItemV10Specs();
        if (typeof window.refreshProductRender === 'function') window.refreshProductRender();
    }

    function trapTab(event, container) {
        var controls = Array.prototype.slice.call(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (control) { return !control.closest('[inert]'); });
        if (!controls.length) return;
        var first = controls[0];
        var last = controls[controls.length - 1];
        if (event.shiftKey && (document.activeElement === first || !container.contains(document.activeElement))) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    function handleDialogClick(event) {
        var fretCount = event.target.closest('[data-fret-count]');
        if (fretCount) {
            var system = workingSystems()[currentFamily];
            var selectedOption = optionById(system, system.selected);
            var material = selectedOption ? fretMaterialLabel(selectedOption.label) : N_('S.STEEL');
            fretCountDraft = fretCount.dataset.fretCount;
            var next = fretOptionFor(system, fretCountDraft, material === 'FRETLESS' ? N_('S.STEEL') : material) || fretOptionFor(system, fretCountDraft, N_('S.STEEL'));
            if (next) chooseProperty(currentFamily, next.id); else renderFocusedFamily();
            var focused = dialogBody.querySelector('[data-fret-count][aria-checked="true"]');
            if (focused) focused.focus();
            return;
        }
        var back = event.target.closest('[data-config-back]');
        if (back) {
            choiceView = 'status';
            choiceSlot = '';
            renderFocusedFamily();
            var statusControl = dialogBody.querySelector('[data-config-expand]');
            if (statusControl) statusControl.focus();
            return;
        }
        var expand = event.target.closest('[data-config-expand]');
        if (expand) {
            choiceView = expand.dataset.configExpand;
            choiceSlot = expand.dataset.configSlot || '';
            renderFocusedFamily();
            var backControl = dialogBody.querySelector('[data-config-back]');
            if (backControl) backControl.focus();
            return;
        }
        var slotChoice = event.target.closest('[data-slot-model]');
        if (slotChoice) {
            chooseSlotModel(+slotChoice.dataset.configIndex, slotChoice.dataset.configSlot, slotChoice.dataset.slotModel);
            return;
        }
        var packChoice = event.target.closest('[data-config-pack]');
        if (packChoice) {
            choosePack(+packChoice.dataset.configIndex, packChoice.dataset.configPack);
            return;
        }
        var presetOption = event.target.closest('[data-preset-option]');
        if (presetOption) {
            choosePreset(+presetOption.dataset.configIndex, presetOption.dataset.presetOption);
            return;
        }
        var propOption = event.target.closest('[data-prop-option]');
        if (propOption) {
            chooseSlotProperty(+propOption.dataset.configIndex, propOption.dataset.configSlot, propOption.dataset.propOption);
            return;
        }
        var modelOption = event.target.closest('[data-model-option]');
        if (modelOption) {
            chooseModel(+modelOption.dataset.configIndex, modelOption.dataset.modelOption);
            return;
        }
        var option = event.target.closest('[data-config-option]');
        if (option) chooseProperty(+option.dataset.configIndex, option.dataset.configOption);
    }

    function bind() {
        if (bound) return false;
        overlay = document.getElementById('config-overlay');
        if (!overlay) return false;
        bound = true;
        dialogBody = document.getElementById('config-dialog-body');
        dialogTitle = document.getElementById('config-dialog-title');
        dialogExplanation = document.getElementById('config-dialog-explanation');
        helpTitle = document.getElementById('config-choice-help-title');
        helpCopy = document.getElementById('config-choice-help-copy');
        pendingLabel = document.getElementById('config-pending-label');
        commitStatus = document.getElementById('config-commit-status');
        applyButton = document.querySelector('[data-config-apply]');
        priceChange = document.getElementById('config-price-change');
        resetOverlay = document.getElementById('reset-confirm-overlay');
        choiceSr = document.getElementById('spec-choice-sr');
        [overlay, resetOverlay].forEach(function (element) {
            if (element && element.parentElement !== document.body) {
                element.classList.add('item-v10');
                document.body.appendChild(element);
            }
        });
        dialogBody.addEventListener('click', handleDialogClick);
        ['pointerover', 'focusin'].forEach(function (type) {
            dialogBody.addEventListener(type, function (event) {
                var choice = event.target.closest('[data-config-option],[data-prop-option],[data-preset-option],[data-model-option],[data-fret-count],[data-slot-model],[data-config-pack],[data-config-expand]');
                if (choice) showHelp(choice);
            });
        });
        dialogBody.addEventListener('pointerout', function (event) {
            var choice = event.target.closest('[data-config-option],[data-prop-option],[data-preset-option],[data-model-option],[data-fret-count],[data-slot-model],[data-config-pack],[data-config-expand]');
            if (choice && !choice.contains(event.relatedTarget)) overlay.classList.remove('has-active-help');
        });
        overlay.addEventListener('click', function (event) {
            if (event.target.closest('[data-config-apply]')) {
                if (draftChanged()) closeOverlay(true);
                return;
            }
            if (event.target.closest('[data-config-cancel],[data-config-close]')) {
                closeOverlay(false);
                return;
            }
            if (event.target.closest('button,a,input,select,textarea,[role="radio"]')) return;
            closeOverlay(false);
        });
        resetOverlay.addEventListener('click', function (event) {
            if (event.target.closest('[data-reset-confirm-apply]')) {
                restoreStoreBuild();
                return;
            }
            if (event.target.closest('[data-reset-confirm-close]')) closeReset();
        });
        document.addEventListener('click', function (event) {
            var resetTrigger = event.target.closest('[data-quick-config-reset]');
            if (resetTrigger) {
                openReset(resetTrigger);
                return;
            }
            var familyTrigger = event.target.closest('[data-config-open-index]');
            if (familyTrigger) openFamily(+familyTrigger.dataset.configOpenIndex, familyTrigger);
        });
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                if (resetOverlay.classList.contains('open')) { closeReset(); return; }
                if (overlay.classList.contains('open')) { closeOverlay(false); return; }
                return;
            }
            if (resetOverlay.classList.contains('open')) {
                if (event.key === 'Tab') trapTab(event, resetOverlay);
                return;
            }
            if (!overlay.classList.contains('open')) return;
            var radio = event.target.closest && event.target.closest('[role="radio"]');
            if (radio && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(event.key) >= 0) {
                var group = radio.closest('[role="radiogroup"]');
                var radios = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]:not([disabled])'));
                var index = radios.indexOf(radio);
                var nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? radios.length - 1 : (index + ((event.key === 'ArrowRight' || event.key === 'ArrowDown') ? 1 : -1) + radios.length) % radios.length;
                event.preventDefault();
                radios.forEach(function (control) { control.tabIndex = -1; });
                radios[nextIndex].tabIndex = 0;
                radios[nextIndex].focus();
                updateHelp(radios[nextIndex]);
                return;
            }
            if (event.key === 'Tab') trapTab(event, overlay);
        });
        return true;
    }

    window.initItemV10QuickConfig = function () {
        if (!document.querySelector('.item-v10')) return;
        bind();
        systems = buildSystems();
        if (!systems.length) return;
        storeBuild = comparable(systems);
        refreshFoundation();
    };

    window.SHARK_ITEM_CONFIG = {
        systems: function () { return systems; },
        changed: function (id) {
            var system = systems.find(function (candidate) { return candidate.id === id; });
            return !!system && systemChanged(system);
        },
        selectedOption: function (id) {
            var system = systems.find(function (candidate) { return candidate.id === id; });
            return system && system.kind === 'property' ? optionById(system, system.selected) : null;
        },
        slots: function (id) {
            var system = systems.find(function (candidate) { return candidate.id === id; });
            return (system && system.slots) || [];
        },
        matchingPackName: function (id) {
            var system = systems.find(function (candidate) { return candidate.id === id; });
            if (!system || system.kind !== 'pack') return '';
            var pack = matchingPack(system);
            return pack ? pack.pack_name : '';
        },
        swapByModel: swapByModel,
        open: function (id, trigger) {
            var index = systems.findIndex(function (candidate) { return candidate.id === id; });
            if (index >= 0) openFamily(index, trigger || null);
        }
    };
})();
